var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThreeDotsHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 5,
    viewBox: "0 0 14 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.94903V4.93968L1.97808 4.93547L3.95616 4.93126V2.94903V0.9668L1.97808 0.962587L0 0.958374V2.94903ZM5.01716 0.979175C5.0128 0.99062 5.01115 1.88451 5.01351 2.96562L5.01777 4.93126H7H8.98223V2.94903V0.9668L7.00365 0.962587C5.42953 0.959237 5.02346 0.96262 5.01716 0.979175ZM10.0432 0.979241C10.0388 0.990654 10.0372 1.88451 10.0396 2.96562L10.0438 4.93126L12.0219 4.93547L14 4.93968V2.94909V0.958507H12.0256C10.4613 0.958507 10.0494 0.962819 10.0432 0.979241ZM1.04502 2.94903V3.87794H1.98223H2.91943V2.94903V2.02012H1.98223H1.04502V2.94903ZM6.07109 2.94903V3.87794H7H7.92891V2.94903V2.02012H7H6.07109V2.94903ZM11.0806 2.94903V3.87794H12.0178H12.955V2.94903V2.02012H12.0178H11.0806V2.94903Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDotsHorizontal);
export default __webpack_public_path__ + "static/media/icon--three-dots-horizontal.2aa9aaba3df5cbe3e709ea296044eee9.svg";
export { ForwardRef as ReactComponent };